import axios from "axios";
import { FIRMFLOWURL } from "./url";

export const INVITATION_UNAVAILABLE_MESSAGE =
    "This invitation is invalid, expired, or already used. Please contact your administrator for another invitation.";

// Invitation errors are deliberately reduced to status and safe text; neither
// raw server messages nor Axios config may reach notifications or monitoring.
function invitationError(error) {
    const status = error.response?.status;
    return {
        success: false,
        status,
        message: !status
            ? "Unable to reach the server. Please check your connection and try again."
            : status >= 500 || status === 429
            ? "Invitation service is temporarily unavailable. Please try again later."
            : INVITATION_UNAVAILABLE_MESSAGE,
    };
}

export async function validateInvitation(token) {
    try {
        const response = await axios.get(`${FIRMFLOWURL}api/Auth/invitation`, {
            params: { token }, suppressForbiddenToast: true, timeout: 30000,
        });
        return { success: true, data: response.data };
    } catch (error) {
        return invitationError(error);
    }
}

export async function acceptInvitation(token, password) {
    try {
        const response = await axios.post(`${FIRMFLOWURL}api/Auth/accept-invitation`,
            { token, password }, { suppressForbiddenToast: true, timeout: 30000 });
        return { success: true, data: response.data };
    } catch (error) {
        return invitationError(error);
    }
}
